export enum AggregationFileType {
    Xls = "XLS",
    Csv = "CSV",
}
